import { ForwardedRef, forwardRef, useEffect, useRef } from "react";

type ICheckbox = {
  name: string;
  id: string;
  label: string;
  defaultChecked: boolean;
};

const Checkbox = (
  { name, id, label, defaultChecked }: ICheckbox,
  ref: ForwardedRef<HTMLInputElement>
) => {
  const checkboxRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    if (checkboxRef.current && defaultChecked) {
      checkboxRef.current.checked = defaultChecked;
    }
  }, [defaultChecked]);

  return (
    <>
      <input
        ref={checkboxRef}
        type="checkbox"
        id={id}
        name={name}
        defaultChecked={defaultChecked}
        onChange={(e) => {
          const parent = e.currentTarget.closest("ul") as HTMLUListElement;
          const checkboxs = parent.querySelectorAll(
            'input[type="checkbox"]'
          ) as NodeListOf<HTMLInputElement>;

          //전체동으
          if (id === "all") {
            checkboxs.forEach((checkbox: HTMLInputElement) => {
              checkbox.checked = e.currentTarget.checked;
              checkbox.setAttribute("data-type", "U");
            });
          }

          if (id !== "all") {
            const [all, ...items] = Array.from(checkboxs);

            let isAllCheck = Array.from(items).every((check) => {
              return check.checked;
            });

            items.forEach((item) => {
              all.checked = isAllCheck;
            });
          }
        }}
      />
      <label
        htmlFor={id}
        onClick={(e) => {
          const prev = e.currentTarget.previousSibling as HTMLInputElement;
          prev.setAttribute("data-type", "U");
        }}
      >
        {label}
      </label>
    </>
  );
};

export default forwardRef<HTMLInputElement, ICheckbox>(Checkbox);
